export const unflattenQueryString = (queryString) => {
    const params = new URLSearchParams(queryString);
    let result = {};

    for (const [key, value] of params.entries()) {
        const keys = key.split(import.meta.env.VITE_FILTER_QUERY_DELIMITER);
        keys.reduce((acc, k, index) => {
            // Convert numeric keys to numbers for arrays
            const isArrayKey = !isNaN(parseInt(k));
            const keyName = isArrayKey ? parseInt(k) : k;

            // If it's the last key, set the value
            if (index === keys.length - 1) {
                acc[keyName] = value;
            } else {
                // If the key does not exist or is not an object/array, create an empty object or array
                if (!acc[keyName] || (typeof acc[keyName] !== 'object' && !Array.isArray(acc[keyName]))) {
                    acc[keyName] = isArrayKey ? [] : {};
                }
            }
            return acc[keyName];
        }, result);
    }

    return result;
  }

export const flattenObject = (ob) => {
    let toReturn = {};
    for (let i in ob) {
        if (!ob.hasOwnProperty(i)) continue;
        if (typeof ob[i] === 'object' && ob[i] !== null) {
            let flatObject = flattenObject(ob[i]);
            for (let x in flatObject) {
                if (!flatObject.hasOwnProperty(x)) continue;
                toReturn[i + import.meta.env.VITE_FILTER_QUERY_DELIMITER + x] = flatObject[x];
            }
        } else {
            toReturn[i] = ob[i];
        }
    }
    return toReturn;
};
